import React from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';
import AppConstants from '../AppConstants';
import { useAPI } from '../contexts/APIContext.js';
import { useStorage } from '../contexts/StorageContext.js';
import CloudBackground from '../elements/CloudBackground.jsx';
import FadeIn from '../elements/FadeIn.jsx';
import SmallButton from '../elements/SmallButton';
import styles from '../Styles';

const localStyles = StyleSheet.create({
  signinField: {
    fontSize: 18,
    borderRadius: 20,
    borderColor: '#333',
    backgroundColor: '#efefef',
    padding: 20,
    borderWidth: 1,
    width: '100%',
    marginVertical: 5,
  },
  titleContainer: {
    marginTop: 80,
    marginBottom: 40,
  },
  titleText: {
    color: 'white',
    fontSize: 36,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  mainContainer: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  formContainer: {
    width: '100%',
    maxWidth: 400,
  },
  formCard: {
    backgroundColor: 'white',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    minWidth: 300,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 4,
  },
  fieldContainer: {
    marginBottom: 15,
    width: '100%',
  },
  lastFieldContainer: {
    marginBottom: 20,
    width: '100%',
  },
  errorText: {
    textAlign: 'center',
    color: 'red',
    marginTop: 10,
  },
  signupText: {
    textAlign: 'center',
    fontSize: 12,
    color: '#666',
    marginTop: 10,
  },
  signupLink: {
    fontSize: 12,
    color: '#007AFF',
    textDecorationLine: 'underline',
  },
  versionText: {
    textAlign: 'center',
    marginTop: 5,
    fontSize: 12,
    color: '#666',
  },
});

const ScreenSignin = () => {
  const [formValues, setFormValues] = React.useState({email: '', code: ''});
  const [error, setError] = React.useState('');
  const [isSigningIn, setIsSigningIn] = React.useState(false);

  const storageContext = useStorage();
  const apiContext = useAPI();

  const _onSignin = async () => {
    console.log("Signing in with", formValues);
    setError(''); // Clear any previous errors
    setIsSigningIn(true);
    
    try {
      const signinSuccess = await apiContext.signin(formValues.email, formValues.code);
      console.log("Signin success:", signinSuccess);
      
      if (signinSuccess) {
        setError('');
        await storageContext.setVoyagerCode(formValues.code);
        await apiContext.fetchData(formValues.code);
      } else {
        setError('Signin failed - please try again');
      }
    } catch (err) {
      console.log("Signin error:", err);
      setError('Signin failed - please try again');
    } finally {
      setIsSigningIn(false);
    }
  };

  return (    
    <CloudBackground>
      <FadeIn delay={0}>
        <View style={localStyles.titleContainer}>
          <Text style={localStyles.titleText}>HereNowThis</Text>
        </View>
      </FadeIn>
      <View style={localStyles.mainContainer}>
        <FadeIn delay={2}>
          <View style={localStyles.formContainer}>
            <View style={localStyles.formCard}>
              <Text style={[styles.helpTextLarge, {marginBottom: 20}]}>Please sign in:</Text>
              <View style={localStyles.fieldContainer}>
                <TextInput
                  style={localStyles.signinField}
                  value={formValues.email}
                  placeholder="Email Address"
                  keyboardType="email-address"
                  autoCapitalize="none"
                  onChangeText={(text) => setFormValues({...formValues, email: text})}               
                />
              </View>
              <View style={localStyles.lastFieldContainer}>
                <TextInput
                  style={localStyles.signinField}
                  value={formValues.code}
                  placeholder="Code (e.g. 123-456)"
                  onChangeText={(text) => setFormValues({...formValues, code: text})}
                />
              </View>
              <SmallButton 
                onPress={_onSignin} 
                title="Sign In" 
                disabled={isSigningIn} 
              />
              {error ? <Text style={localStyles.errorText}>{error}</Text> : null}
              <Text style={localStyles.versionText}>
                {AppConstants.VERSION_ID}
              </Text>
            </View>
          </View>
        </FadeIn>
      </View>
    </CloudBackground>
  );
};

export default ScreenSignin;
